import { Component, Input, OnDestroy } from '@angular/core';
import { Utils } from 'src/app/common/utils';

import { environment } from 'src/environments/environment';

import { CosteModel } from 'src/app/models/coste.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';

@Component({
    selector: 'app-costes-tareas-fitosanitarios',
    standalone: false,
    templateUrl: './costes-tareas-fitosanitarios.component.html',
    styleUrls: ['./costes-tareas-fitosanitarios.component.scss']
})
export class CostesTareasFitoSanitarioComponent implements OnDestroy {
    @Input() model: CosteModel = {};
    // public menuItemId = 'costes-tareas';

  
    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;
    public appName = environment.appName;

    public canShow: Record<string, boolean> = {};
   
    public ps = 0;

    public mostrarTratamientosAplicados = true;


    public distributionOrder = [4];

  
    auxTotalTrabajadores = 0;
    showTarea = false;
    showTareaFito = false;
    showTareaFerti = false;

 
    constructor() {
       
    }

    public moneyFormat(input: number) {
        return Utils.decimalFormat(input, 2);
    }

    public cuantityFormat(input: number) {
        return Utils.decimalFormat(input, 1);
    }

    public show(modal: string, data: CosteModel) {
        let x;

        this.model = data;
        this.canShow[modal] = true;

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }
    }

    public hide(modal: string) {
        this.model = {};
        this.canShow[modal] = false;
      
    }

    public ngOnDestroy() {
        Utils.unsuscribe([
           
        ]);
    }

    public transformStringToNumber( value: string ): number {
        if ( value == null || value.length === 0  ) {
            return 0;
        }
        return parseFloat(value);
    }

    public sumaAuxTrabajadores( horas: string ) {
        const trabajadores: MantenimientoModel[] | null = this.model.lista_trabajadores ?? null;
        let suma =  0;
        if ( trabajadores == null ) {
            return suma;
        }
        for (const trabajador of trabajadores) {
            if (trabajador.aux_cargos == null || horas == null ) {
                suma += 0;
            } else {
                suma += trabajador.aux_cargos * this.transformStringToNumber(horas);
            }
        }
        return suma;
    }


    public tipoTarea( tarea: string ) {
        this.showTarea = false;
        this.showTareaFito = false;
        this.showTareaFerti = false;
        if ( tarea == null || tarea.length === 0) {
            this.showTarea = true;
            return;
        }

        if ( tarea === 'Tareas fitosanitarias' ) {
            this.showTareaFito = true;
            return;
        }
        
        if ( tarea === 'Tareas fertilizantes' ) {
            this.showTareaFerti = true;
            return;
        }
        this.showTarea = true;
        return;

    }
}